"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDepartmentApi = void 0;
exports.createDepartmentApi = (axios) => ({
    listDepartments() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get('/departments')).data;
        });
    },
    createDepartment(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post('/departments', props)).data;
        });
    },
    updateDepartment(_a) {
        var { departmentId } = _a, rest = __rest(_a, ["departmentId"]);
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.put(`/department/${departmentId}`, rest)).data;
        });
    },
    deleteDepartment(props) {
        return __awaiter(this, void 0, void 0, function* () {
            yield axios.delete(`/department/${props.departmentId}`);
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVwYXJ0bWVudEFwaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hcGkvZGVwYXJ0bWVudEFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdhLFFBQUEsbUJBQW1CLEdBQUcsQ0FBQyxLQUFvQixFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3RELGVBQWU7O1lBQ25CLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxHQUFHLENBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7UUFDaEQsQ0FBQztLQUFBO0lBRUssZ0JBQWdCLENBQUMsS0FBdUI7O1lBQzVDLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxJQUFJLENBQUMsY0FBYyxFQUFFLEtBQUssQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDO1FBQ3hELENBQUM7S0FBQTtJQUVLLGdCQUFnQixDQUFDLEVBTXRCO1lBTnNCLEVBQ3JCLFlBQVksT0FLYixFQUpJLElBQUksY0FGYyxnQkFHdEIsQ0FEUTs7WUFLUCxPQUFPLENBQUMsTUFBTSxLQUFLLENBQUMsR0FBRyxDQUFDLGVBQWUsWUFBWSxFQUFFLEVBQUUsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7O0tBQ3BFO0lBRUssZ0JBQWdCLENBQUMsS0FBK0I7O1lBQ3BELE1BQU0sS0FBSyxDQUFDLE1BQU0sQ0FBQyxlQUFlLEtBQUssQ0FBQyxZQUFZLEVBQUUsQ0FBQyxDQUFDO1FBQzFELENBQUM7S0FBQTtDQUNGLENBQUMsQ0FBQyJ9